import { gql } from 'apollo-boost';

export const LIST_FAVOURITE_TUTORS = gql`
	query LIST_FAVOURITE_TUTORS {
		listFavouriteTutor {
			pvid
			firstName
			lastName
			address
			token
			pricePerHour
			experienceYears
			resource {
				path
			}
			experienceLevel
			experienceSubject
			experienceCurriculum
			experienceYears
		}
	}
`;

export const ADD_TO_FAVOURITE = gql`
	mutation ADD_TO_FAVOURITE($tutorPvid: Int!) {
		addFavouriteTutor(TutorPvid: $tutorPvid) {
			text
			success
		}
	}
`;
export const DELETE_FROM_FAVOURITE = gql`
	mutation DELETE_FROM_FAVOURITE($tutorPvid: Int!) {
		removeFavTutor(TutorPvid: $tutorPvid) {
			text
			success
		}
	}
`;
